import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function greaterThanZeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null; // Don't validate empty values here; use `Validators.required` if needed
    }

    const numberValue = parseFloat(value);
    return numberValue > 0 ? null : { greaterThanZero: true };
  };
}
